import {
  IFormDefinition,
  IFormValues,
  PendingRemoveAttachmentOperations,
} from "@entaconsulting/form";
import httpClient from "common/api/httpClient";
import { FormDefinition } from "developer/formsCRUD/store/formDefinitionsSlice";
import { FormState } from "store/form/formDataSlice";
import { IDynamicFormDefinition, ISharedFormInstance } from "./types";

export const getFormData = async (formKey: string) => {
  const { data: responseData } = await httpClient.get("fill", {
    params: {
      sharedformtoken: formKey,
    },
  });

  const formData = {
    formDefinition: JSON.parse(responseData.formDefinition || "{}"),
    initialValues: JSON.parse(responseData.initialValues || "{}"),
    eTag: responseData.eTag,
    attachmentsWorkspaceId: responseData.attachmentsWorkspaceId,
    state: responseData.state,
    lastSaved: responseData.lastSaved,
  } as ISharedFormInstance;
  return formData;
};

export const getFormDefinition = async (
  formDefinitionId: string
): Promise<IDynamicFormDefinition> => {
  const response = await httpClient.get<
    {
      definition: IFormDefinition;
      sampleData: IFormValues;
    } & FormDefinition
  >(`formdefinition/${formDefinitionId}`);
  const data = response.data;
  const formDefinition: IFormDefinition = data.definition;
  const initialValues: IFormValues = data.sampleData ? data.sampleData : {};

  const { id, name, description, disabled, workspaceId } = data;

  return {
    formDefinition,
    initialValues,
    id,
    name,
    description,
    disabled,
    workspaceId,
  };
};

export const postForm = async (
  formKey: string,
  values: IFormValues,
  pendingRemoveAttachmentOperations: PendingRemoveAttachmentOperations[],
  eTag: string,
  attachmentsWorkspaceId: string,
  draft: boolean
): Promise<{
  eTag: string;
  attachmentsWorkspaceId: string;
  lastSaved: string;
  state: FormState;
}> => {
  const data = {
    Values: JSON.stringify(values),
    removeAttachments: pendingRemoveAttachmentOperations,
    eTag,
    attachmentsWorkspaceId,
    draft,
  };

  const response = await httpClient.post("fill", data, {
    params: {
      sharedformtoken: formKey,
    },
  });
  const responseData = response.data;

  return {
    eTag: responseData.eTag,
    attachmentsWorkspaceId: responseData.attachmentsWorkspaceId,
    lastSaved: responseData.lastSaved,
    state: responseData.state,
  };
};

export const putFormDefinitionMetadata = async (
  formDefinitionId: string,
  formDefinition: IFormDefinition
): Promise<{ eTag: string }> => {
  const data = formDefinition;

  const response = await httpClient.put<{ eTag: string }>(
    `formdefinition/metadata/${formDefinitionId}`,
    data
  );

  return {
    eTag: response.data.eTag,
  };
};

export const putSampleData = async (
  formDefinitionId: string,
  values: IFormValues
): Promise<string> => {
  const data = values;

  const response = await httpClient.put(
    `formdefinition/sampledata/${formDefinitionId}`,
    data
  );

  return response.data;
};
